import { keepPreviousData } from '@tanstack/react-query';
import {
    AGGREGATE_NAMES,
    CONSORS_DOWNLOAD_SUBSCRIPTION_DOCUMENT_REQUEST_STATUSES,
    LOAN_REQUEST_RESOLVERS,
} from 'cpool-constants';
import { schemaLoanRequestResolver_GetConsorsSubscriptionStatus } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

export const CONSORS_DOCUMENT_DOWNLOAD_POLLING_INTERVAL_MS = 10_000;

export const useConsorsSubscriptionStatus = ({
    loanRequestId,
    subscriptionIdentifier,
}: {
    loanRequestId: string;
    subscriptionIdentifier?: string | null;
}) => {
    return useAggregateQuery({
        acl: { loanRequestId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getConsorsSubscriptionStatus,
        schema: schemaLoanRequestResolver_GetConsorsSubscriptionStatus,
        searchParams: { id: loanRequestId, subscriptionIdentifier },
        tanstack: {
            placeholderData: keepPreviousData,
            // cobra downloads the document asynchronously; poll until it is no longer pending
            refetchInterval: (query) =>
                query.state.data?.documentDownload?.status ===
                CONSORS_DOWNLOAD_SUBSCRIPTION_DOCUMENT_REQUEST_STATUSES.PENDING
                    ? CONSORS_DOCUMENT_DOWNLOAD_POLLING_INTERVAL_MS
                    : false,
        },
    });
};
